import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

interface AvisoAtualizacaoProps {
  isOpen: boolean;
  progresso: number;
  mensagem?: string;
}

export const AvisoAtualizacao: React.FC<AvisoAtualizacaoProps> = ({
  isOpen,
  progresso,
  mensagem = 'Atualizando'
}) => {
  const [portalElement, setPortalElement] = useState<HTMLElement | null>(null);

  useEffect(() => {
    // Criar elemento para o portal apenas quando o componente for montado
    if (isOpen && !portalElement) {
      const element = document.createElement('div');
      element.id = 'fonte-atualizacao-modal';
      document.body.appendChild(element);
      setPortalElement(element);
    }

    // Limpar o elemento do portal quando o componente for desmontado
    return () => {
      if (portalElement && portalElement.parentNode) {
        portalElement.parentNode.removeChild(portalElement);
        setPortalElement(null);
      }
    };
  }, [isOpen, portalElement]);

  if (!isOpen || !portalElement) return null;

  return createPortal(
    <div className="fixed inset-0 z-[9999] overflow-y-auto">
      <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity"></div>
      <div className="flex min-h-full items-center justify-center p-4">
        <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full p-6">
          <h3 className="text-lg font-medium text-blue-600 mb-4">
            Atualização do Sistema
          </h3>
          <p className="text-gray-700 mb-6">
            Parabéns! Existe uma atualização do sistema, novas funcionalidades e melhorias estão sendo implementadas.
          </p>            
          <div className="w-full bg-gray-200 h-8 mb-4">
            <div 
              className="bg-blue-600 h-8" 
              style={{ width: `${Math.min(Math.max(progresso, 0), 100)}%` }}
            />
          </div>
          <p className="text-gray-700 mb-6 text-center">
            {mensagem} - {progresso}%
          </p>
        </div>
      </div>
    </div>,
    portalElement
  );
}; 